import React, { useState } from 'react'
import {
    Modal as MuiModal,
    Box,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    CircularProgress,
    Alert
} from '@mui/material'
import { updateWorkLocation } from '../../../services/AttendanceService'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 400 },
    bgcolor: 'background.paper',
    boxShadow: 3,
    p: 4,
    borderRadius: 2
}
const locationWorkingAtMap = {
    HOME: 1,
    OFFICE: 2,
    OFFSITE: 3
}
const AttendanceUpdate = ({ open, onClose, employee }) => {
    const [workingAt, setWorkingAt] = useState('')
    const [loading, setLoading] = useState(false)
    const [responseMessage, setResponseMessage] = useState('')

    const handleUpdate = async () => {
        setLoading(true)
        setResponseMessage('')

        try {
            const request = {
                workingAt: locationWorkingAtMap[workingAt],
                id: employee.id
            }

            const response = await updateWorkLocation(request)
            setResponseMessage(response.messs)
        } catch (error) {
            console.error('Error updating status:', error)
            setResponseMessage('Failed to update work location.')
        } finally {
            setLoading(false)
            setTimeout(() => {
                onClose()
                setWorkingAt('')
                setResponseMessage('')
            }, 1500) // Close after showing message briefly
        }
    }

    return (
        <MuiModal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" gutterBottom>
                    Update Work Location
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                    {employee.fullName}
                </Typography>

                <FormControl fullWidth sx={{ mb: 2, mt: 1 }}>
                    <InputLabel id="working-at-label">Working At</InputLabel>
                    <Select
                        labelId="working-at-label"
                        value={workingAt}
                        label="Working At"
                        onChange={(e) => setWorkingAt(e.target.value)}
                        disabled={loading}
                    >
                        <MenuItem value="OFFICE">OFFICE</MenuItem>
                        <MenuItem value="HOME">HOME</MenuItem>
                    </Select>
                </FormControl>

                {responseMessage && (
                    <Alert severity={responseMessage.includes('successfully') ? 'success' : 'error'} sx={{ mb: 2 }}>
                        {responseMessage}
                    </Alert>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={onClose} variant="outlined" disabled={loading}>
                        Cancel
                    </Button>
                    <Button onClick={handleUpdate} variant="contained" disabled={!workingAt || loading}>
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Update'}
                    </Button>
                </Box>
            </Box>
        </MuiModal>
    )
}

export default AttendanceUpdate
